import { createRoute } from "@tanstack/react-router";
import { TeamPlaceholderPage } from "@/components/teams/team-placeholder-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/created/marketing",
  component: () => <TeamPlaceholderPage team="Created Team – Marketing" />,
});
